import { useState, type FormEvent } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'

const API = 'https://zumo-api.megan.qzz.io'
const FIREBASE_KEY = 'AIzaSyBtINAZeMK_-9Di840xg46kTI1IjFdPFdw'

export default function LoginPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [googleLoading, setGoogleLoading] = useState(false)
  const [githubLoading, setGithubLoading] = useState(false)
  const { setUser } = useAuthStore()
  const navigate = useNavigate()

  const handleLogin = async (e: FormEvent) => {
    e.preventDefault()
    setLoading(true); setError('')
    try {
      const res = await fetch(`${API}/v1/auth/login`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      })
      const data = await res.json()
      if (data.token) {
        localStorage.setItem('zumo_token', data.token)
        setUser(data.user)
        navigate('/chat')
      } else {
        setError(data.error || 'Login failed')
      }
    } catch { setError('Network error') }
    setLoading(false)
  }

  const handleGoogle = () => {
    setGoogleLoading(true)
    const script = document.createElement('script')
    script.src = 'https://accounts.google.com/gsi/client'
    script.onload = () => {
      (window as any).google?.accounts.id.initialize({
        client_id: '599593422056-nt8u5hocpec5d5vh0hv2q3qfdvlqpj8e.apps.googleusercontent.com',
        callback: async (res: any) => {
          try {
            const r = await fetch(`${API}/v1/auth/oauth/google`, {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ idToken: res.credential }),
            })
            const d = await r.json()
            if (d.token) { localStorage.setItem('zumo_token', d.token); setUser(d.user); navigate('/chat') }
            else setError(d.error || 'Google sign-in failed')
          } catch { setError('Network error') }
          setGoogleLoading(false)
        },
      })
      (window as any).google?.accounts.id.prompt()
    }
    script.onerror = () => { setGoogleLoading(false); setError('Failed to load Google Sign-In') }
    document.head.appendChild(script)
  }

  const handleGithub = () => {
    const clientId = 'Ov23liudWzw7XoFEuYZq'
    const redirectUri = 'https://zumo.megan.qzz.io/login'
    const scope = 'user:email'
    window.location.href = `https://github.com/login/oauth/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}`
  }

  // Handle GitHub callback
  useState(() => {
    const params = new URLSearchParams(window.location.search)
    const code = params.get('code')
    if (code) {
      setGithubLoading(true)
      fetch(`${API}/v1/auth/oauth/github`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code }),
      }).then(r => r.json()).then(d => {
        if (d.token) { localStorage.setItem('zumo_token', d.token); setUser(d.user); navigate('/chat') }
        else setError(d.error || 'GitHub sign-in failed')
        setGithubLoading(false)
        window.history.replaceState({}, '', '/login')
      }).catch(() => { setError('Network error'); setGithubLoading(false) })
    }
  })

  return (
    <div style={s.container}>
      <div style={s.card}>
        <h1 style={s.logo}>Zumo</h1>
        <p style={s.sub}>Welcome back</p>

        {/* OAuth */}
        <button onClick={handleGoogle} disabled={loading || googleLoading} style={{ ...s.oauthBtn, opacity: loading || googleLoading ? 0.6 : 1 }}>
          <span style={{ ...s.oauthIcon, background: '#4285F4' }}>G</span>
          {googleLoading ? 'Loading...' : 'Continue with Google'}
        </button>
        <button onClick={handleGithub} disabled={loading || githubLoading} style={{ ...s.oauthBtn, opacity: loading || githubLoading ? 0.6 : 1 }}>
          <span style={{ ...s.oauthIcon, background: '#24292e' }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="white"><path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z"/></svg>
          </span>
          {githubLoading ? 'Loading...' : 'Continue with GitHub'}
        </button>

        <div style={s.divider}>
          <span style={s.line} /><span style={s.divText}>or with email</span><span style={s.line} />
        </div>

        {error && <div style={s.error}>{error}<button onClick={() => setError('')} style={s.errClose}>×</button></div>}

        <form onSubmit={handleLogin} style={s.form}>
          <label style={s.label}>Email</label>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} style={s.input} placeholder="you@email.com" required />
          <label style={s.label}>Password</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} style={s.input} placeholder="••••••••" required />
          <button type="submit" disabled={loading} style={{ ...s.btn, opacity: loading ? 0.6 : 1 }}>
            {loading ? 'Signing in...' : 'Log In'}
          </button>
        </form>

        <p style={s.footer}>Don't have an account? <Link to="/signup" style={s.link}>Sign up</Link></p>
      </div>
    </div>
  )
}

const s: Record<string, React.CSSProperties> = {
  container: { display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', width: '100%', background: 'var(--bg-primary)', padding: 20 },
  card: { background: 'var(--bg-secondary)', border: '1px solid var(--border)', borderRadius: 20, padding: 'clamp(24px,5vw,36px)', maxWidth: 400, width: '100%' },
  logo: { fontSize: 32, fontWeight: 800, textAlign: 'center', marginBottom: 4, background: 'linear-gradient(135deg,#00d158,#00ff6e)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' },
  sub: { color: 'var(--text-secondary)', textAlign: 'center', marginBottom: 20, fontSize: 14 },
  oauthBtn: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, padding: 12, background: 'var(--bg-primary)', border: '1px solid var(--border)', borderRadius: 12, color: 'var(--text-primary)', fontSize: 14, fontWeight: 500, cursor: 'pointer', width: '100%', marginBottom: 10, transition: 'opacity 0.2s' },
  oauthIcon: { width: 24, height: 24, borderRadius: 12, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, flexShrink: 0 },
  divider: { display: 'flex', alignItems: 'center', gap: 12, margin: '8px 0 16px' },
  line: { flex: 1, height: 1, background: 'var(--border)' },
  divText: { color: 'var(--text-muted)', fontSize: 11, textTransform: 'uppercase', letterSpacing: 1, whiteSpace: 'nowrap' },
  form: { display: 'flex', flexDirection: 'column', gap: 14 },
  label: { color: 'var(--text-secondary)', fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1 },
  input: { padding: '12px 14px', background: 'var(--bg-primary)', border: '1px solid var(--border)', borderRadius: 10, color: 'var(--text-primary)', fontSize: 14, outline: 'none', width: '100%' },
  btn: { padding: 14, background: 'var(--accent-glow)', border: '1px solid rgba(0,255,106,0.3)', borderRadius: 12, color: 'var(--accent)', fontSize: 15, fontWeight: 600, cursor: 'pointer', marginTop: 4 },
  error: { background: 'rgba(255,68,68,0.1)', border: '1px solid rgba(255,68,68,0.2)', borderRadius: 10, padding: '10px 14px', color: 'var(--danger)', fontSize: 13, marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  errClose: { background: 'none', border: 'none', color: 'var(--danger)', cursor: 'pointer', fontSize: 18 },
  footer: { color: 'var(--text-muted)', textAlign: 'center', marginTop: 20, fontSize: 13 },
  link: { color: 'var(--accent)', textDecoration: 'none', fontWeight: 600 },
}
